// client/src/routes/app/health/index.tsx — SCR-HS-001 „Sănătate portofoliu" · HS-003
// (04 §8.13, §7's route tree, §9.2.3).
//
// Replaces UI-003's `PlaceholderScreen`, which named this item as its owner.
//
// Gated on `Reports.Read` (§6.2), which is the permission HS-002 mounted both endpoints behind
// (D-1438): „a score reads across Leasing, Operations, Documents, Reporting and Fiscal, so any
// single module's code would have granted less than the payload discloses". The sidebar hides
// the entry from a session without it, and this renders SCR-SYS-403 for the URL that was typed
// anyway (§9.2.2).
//
// No ROLE gate beside it, unlike SCR-FISC-001. 03 §17.1 grants `Reports.Read` to the roles 04
// intends to see this screen, and 04 §8.13 prints no role restriction of its own — the health
// score is the product's one-glance answer to „how is this property doing", which is a question
// a manager is employed to answer.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PortfolioHealthScreen } from '@/features/health/PortfolioHealthScreen';
import { healthSearchSchema } from '@/features/health/search';

export const Route = createFileRoute('/app/health/')({
  validateSearch: healthSearchSchema,
  component: HealthScreen,
});

function HealthScreen() {
  const search = Route.useSearch();

  return (
    <RequirePermission permission="Reports.Read">
      <PortfolioHealthScreen search={search} />
    </RequirePermission>
  );
}
